module.exports = __webpack_public_path__ + "static/media/persistence-of-dreams.40877df8.jpeg";